export default {
  apiKey: "AIzaSyCHuojdo9aXyB5Xt7Pp67I8XoDQWQU5alA",
  authDomain: "manage-now.firebaseapp.com",
  projectId: "manage-now",
  storageBucket: "manage-now.appspot.com",
  messagingSenderId: "254879411552",
  appId: "1:254879411552:web:26dd6bbb996eac8226c205",
  measurementId: "G-37YLHKVMC2",
};
